export function formatCount(value: number): string {
  if (value >= 10000) {
    const w = value / 10000;
    return `${w % 1 === 0 ? w.toFixed(0) : w.toFixed(1)}万`;
  }
  return value.toLocaleString("zh-CN");
}